import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import 'amfe-flexible'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';


// 全局自定义组件
import myNavbar from '@/components/common/myNavbar.vue'
import myFooter from '@/components/common/myFooter.vue'

import FarmerApi from "@/http/request/index.js";

Vue.use(ElementUI)
Vue.component('my-navbar', myNavbar)
Vue.component('my-footer', myFooter)

Vue.prototype.$api = FarmerApi

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router
}).$mount('#app')

